import { hy_safetyProjectMonthEvalDetail } from "./hy_safetyProjectMonthEvalDetail.js"
export const hy_safetyProjectMonthEval = {
    "id": "",
    "conunitid": "",
    "conunitmc": "",
    "evalmanid": "",
    "proid": "",
    "proname": "",
    "curyear": 0,
    "curmonth": 0,
    "checkdate": "",
    "evalgrade": 0,
    "evalresult": "",
    "evalidea": "",
    "issgdwsign": 0,
    "sgdwsigndate": "",
    "sgdwxmfzr": "",
    "sgdwxmfzrzsh": "",
    "jsdwid": "",
    "jsdwmc": "",
    "jsdwxmfzr": "",
    "jsdwidea": "",
    "isjsdwsign": "",
    "jsdwsigndate": "",
    "jldwid": "",
    "jldwmc": "",
    "jldwgcsmc": "",
    "jldwgcscard": "",
    "jldwidea": "",
    "isjldwsign": "",
    "jldwsigndate": "",
    "jldwzjlgcs": "",
    "jldwzjlgcscard": "",
    "enddate": "",
    "isover": 0,
    "isend": 0,
    "endworkTime": "",
    "oprid": "",
    "opdate": "",
    "opState": "",
    "opStatemc": "",
    "isdeal": 0,
    "spidea": "",
    "positionid": "",
    "positionname": "",
    "isjsdwdo": 0,
    "isjldwdo": 0,
    "jsdwxmfzrcard": "",
    "aqconfirmdate": "",
    "totalname": "",
    "xianname": "",
    "jsdwendsigndate": "",
    "synTimestamp": "",
    "SafetyProjectmonthevaldetail": "",
    "existproblem": "",
    "changesituation": "",
    safetyProjectMonthEvalDetail: [hy_safetyProjectMonthEval], //on to many hy_safetyProjectMonthEval
    existproblem1: "",
    existproblem2: "",
    existproblem3: "",
    existproblem4: "",
    existproblem5: "",
    existproblem6: "",
    existproblem7: "",
    existproblem8: "",
    existproblem9: "",
    existproblem10: "",
    changesituation1: "",
    changesituation2: "",
    changesituation3: "",
    changesituation4: "",
    changesituation5: "",
    changesituation6: "",
    changesituation7: "",
    changesituation8: "",
    changesituation9: "",
    changesituation10: "",
}


// WEBPACK FOOTER //
// ./src/entity/hy_safetyProjectMonthEval.js